import { render, staticRenderFns } from "./ForEmployers.vue?vue&type=template&id=36d66120&"
import script from "./ForEmployers.vue?vue&type=script&lang=js&"
export * from "./ForEmployers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports